import { render, staticRenderFns } from "./PaymentKlarna.vue?vue&type=template&id=75691e28"
import script from "./PaymentKlarna.vue?vue&type=script&lang=js"
export * from "./PaymentKlarna.vue?vue&type=script&lang=js"
import style0 from "./PaymentKlarna.vue?vue&type=style&index=0&id=75691e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports